// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Public privacy policy (/privacy-policy). Scoped under .privacy-policy-container. */

.privacy-policy-container {
  background-color: var(--ds-bg);
  color: var(--ds-text);
  font-family: var(--ds-font);
  line-height: 1.6;
  padding-block: var(--ds-space-4) var(--ds-space-8);
  padding-inline: var(--ds-space-4);
  overflow-wrap: anywhere;
}

.privacy-policy-container header {
  margin-bottom: var(--ds-space-6);
  padding: var(--ds-space-6) var(--ds-space-4);
  background-color: var(--ds-surface);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
}

.privacy-policy-container .privacy-policy__title {
  margin: 0;
  color: var(--ds-text);
  font-size: clamp(1.75rem, 1.2rem + 3vw, 3rem);
  font-weight: 700;
  line-height: 1.2;
}

.privacy-policy-container .section-title {
  color: var(--ds-text);
  font-size: 1.3rem;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: var(--ds-space-4);
  padding-bottom: var(--ds-space-2);
  border-bottom: 2px solid var(--ds-border-soft);
}

.privacy-policy-container .sub-section-title {
  color: var(--ds-text-2);
  font-size: 1.1rem;
  font-weight: 500;
  margin-top: var(--ds-space-5);
  margin-bottom: var(--ds-space-3);
}

.privacy-policy-container p {
  margin-bottom: var(--ds-space-4);
  text-align: start;
}

.privacy-policy-container section {
  background-color: var(--ds-surface);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  padding: var(--ds-space-4);
  margin-bottom: var(--ds-space-5);
}

.privacy-policy-container .list-group-item {
  background-color: var(--ds-surface-muted);
  border: 1px solid var(--ds-border-soft);
  padding: var(--ds-space-3) var(--ds-space-4);
  color: var(--ds-text);
}

.privacy-policy-container .link-primary {
  display: inline-block;
  padding-block: var(--ds-space-2);
  color: var(--ds-brand-strong);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.privacy-policy-container .link-primary:hover,
.privacy-policy-container .link-primary:focus-visible {
  color: var(--ds-brand-dark);
}

@media (min-width: 768px) {
  .privacy-policy-container {
    padding-block: var(--ds-space-8);
  }

  .privacy-policy-container .section-title {
    font-size: 1.5rem;
  }

  .privacy-policy-container .sub-section-title {
    font-size: 1.25rem;
  }

  .privacy-policy-container section {
    padding: var(--ds-space-6);
  }
}
`, "",{"version":3,"sources":["webpack://./src/privacy-policy/PrivacyPolicy.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,kDAAkD;EAClD,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;EACvC,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Public privacy policy (/privacy-policy). Scoped under .privacy-policy-container. */\n\n.privacy-policy-container {\n  background-color: var(--ds-bg);\n  color: var(--ds-text);\n  font-family: var(--ds-font);\n  line-height: 1.6;\n  padding-block: var(--ds-space-4) var(--ds-space-8);\n  padding-inline: var(--ds-space-4);\n  overflow-wrap: anywhere;\n}\n\n.privacy-policy-container header {\n  margin-bottom: var(--ds-space-6);\n  padding: var(--ds-space-6) var(--ds-space-4);\n  background-color: var(--ds-surface);\n  border-radius: var(--ds-radius-md);\n  box-shadow: var(--ds-shadow-sm);\n}\n\n.privacy-policy-container .privacy-policy__title {\n  margin: 0;\n  color: var(--ds-text);\n  font-size: clamp(1.75rem, 1.2rem + 3vw, 3rem);\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.privacy-policy-container .section-title {\n  color: var(--ds-text);\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-top: 0;\n  margin-bottom: var(--ds-space-4);\n  padding-bottom: var(--ds-space-2);\n  border-bottom: 2px solid var(--ds-border-soft);\n}\n\n.privacy-policy-container .sub-section-title {\n  color: var(--ds-text-2);\n  font-size: 1.1rem;\n  font-weight: 500;\n  margin-top: var(--ds-space-5);\n  margin-bottom: var(--ds-space-3);\n}\n\n.privacy-policy-container p {\n  margin-bottom: var(--ds-space-4);\n  text-align: start;\n}\n\n.privacy-policy-container section {\n  background-color: var(--ds-surface);\n  border-radius: var(--ds-radius-md);\n  box-shadow: var(--ds-shadow-sm);\n  padding: var(--ds-space-4);\n  margin-bottom: var(--ds-space-5);\n}\n\n.privacy-policy-container .list-group-item {\n  background-color: var(--ds-surface-muted);\n  border: 1px solid var(--ds-border-soft);\n  padding: var(--ds-space-3) var(--ds-space-4);\n  color: var(--ds-text);\n}\n\n.privacy-policy-container .link-primary {\n  display: inline-block;\n  padding-block: var(--ds-space-2);\n  color: var(--ds-brand-strong);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.privacy-policy-container .link-primary:hover,\n.privacy-policy-container .link-primary:focus-visible {\n  color: var(--ds-brand-dark);\n}\n\n@media (min-width: 768px) {\n  .privacy-policy-container {\n    padding-block: var(--ds-space-8);\n  }\n\n  .privacy-policy-container .section-title {\n    font-size: 1.5rem;\n  }\n\n  .privacy-policy-container .sub-section-title {\n    font-size: 1.25rem;\n  }\n\n  .privacy-policy-container section {\n    padding: var(--ds-space-6);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
